import { SimpleGrid } from '@backyard-ui/core';

import { type Response as GetSummaryResponse } from '@/infra/services/catalog/review/get-summary';
import { RatingResume } from '@/presenters/components/catalog/RatingResume';

import StarResume from './StarResume';

interface ResumeProps {
  summary: GetSummaryResponse['data'];
}

export default function Resume(props: Readonly<ResumeProps>) {
  const { summary } = props;

  if (!summary.generalScores) {
    return null;
  }

  return (
    <SimpleGrid
      gapY="10"
      columns={{ sm: 1, md: 2 }}
      data-testid="reviews-resume"
    >
      <RatingResume
        distribution={summary.generalScores.distribution}
        totalReviewsCount={summary.generalScores.statistics.totalReviewsCount}
        size="md"
      />
      <StarResume avgRating={summary.generalScores?.statistics.avgRating} />
    </SimpleGrid>
  );
}
